






























































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class YhqxNavLeft extends Vue {
  @Prop()
  private cState;
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 跳转账户管理
   */
  private jumpZhgl() {
    localStorage.setItem(
      "zhglFilter",
      JSON.stringify({
        search: "",
        institution_id: "",
        current_page: 1,
        page_count: 10,
        sort_value: "0",
      })
    );
    this.$router.push("/main/yhqx/zhgl-list");
  }
  /**
   * @description 跳转邀请码管理
   */
  private jumpYqmList() {
    localStorage.setItem(
      "yqmFilter",
      JSON.stringify({
        current_page: 1,
        page_count: 10,
        sort_value: "0",
      })
    );
    this.$router.push("/main/yhqx/yqm-list");
  }
}
